var isW;
var shoeLast = [0,0];
var sizeLast = [0,0,0];
var ma_sys = [0,0];
var c_l_m_b = 0;

var table = [["#height-ft","","",""],
             ["#height-in","","",""],
       	     ["#height-cm","","",""],
             ["#weight","","",""],
             ["#shoe_size","","",""],
             ["#m-1-1","","",""],
             ["#m-2-1","","",""],
    		 ["#m-3-1","","",""],
      		 ["#m-4-1","","",""],
             ["#m-5-1","","",""],
             ["#m-6-1","","",""]];
  

$(document).ready(function(){
 
 
  var p_n = $('#product-name-id').text();

  if(p_n.toLowerCase().includes('women')) { 
    isW = true; 
    $("#m-2-0").hide(); 
    $("#m-2-1").attr("required",false)
    $("#m-3-0,#m-4-0").show(); 
    $("#m-3-1,#m-4-1").attr("required",true)
  } else { 
    isW = false; 
    $("#m-2-0").show(); 
    $("#m-2-1").attr("required",true)
    $("#m-3-0,#m-4-0").hide(); 
    $("#m-3-1,#m-4-1").attr("required",false)
  }
  
  function getValues(start,sys) {
    var t;
    
    for (var i = start; i < table.length; i++) {
      
      t = $(table[i][0]).val();
      if (t != "") { 
        table[i][sys+1] = t;
      }
      
    }
    
  }
  
  function setValues(start,sys) {
    for (var i = start; i < table.length; i++) {
      if (table[i][sys+1] != "") {
        $(table[i][0]).val(table[i][sys+1]);
      }
    }
  }
  
  function eraseValues(start) {
    
    for (var i = start; i < table.length; i++) {
      
      $(table[i][0]).val(""); 
      
    }
   
  }
  
  function getOptionIndex(str) {
    
    var s_list = ["product-select-option-0","product-select-option-1","product-select-option-2"];
    var o_list = [["sock",-1],["color",-1],["ds_size",-1]];
    var s_s_s;
    var x = [2,1,0];
    
    for (var i = 0; i < s_list.length; i++) {
      
      for (var j = 0; j < o_list.length; j++) {    
        
        s_s_s = $('label[for="' + s_list[i] + '"]').html();
        
        if ( s_s_s.toLowerCase().includes( o_list[j][0] ) ) {
          o_list[j][1] = i;
          
        }
        
      }
          
    }
    
    var sum = 0;
    for (var k = 0; k < o_list.length; k++ ) {
      
      sum = sum + o_list[k][1];
      
    }
    
    o_list[2][1] = x[sum];
    //console.log("o_list: " + o_list);
    
    for (var i = 0; i < o_list.length; i++ ) {
          
      if ( o_list[i][0].includes( str ) ) {
        s_s_s = o_list[i][1];
        break;
      }
          
    }
        
    return s_s_s;
    
  }
  
  function initialize(v1,v2,va3) {
    
    var p_l_1 = ["weight","shoe size","chest measure","belly measure","waist measure","hip measure","sleeve measure","inseam measure"];
    var p_l_2 = ["#weight","#shoe_size","#m-1-1","#m-2-1","#m-3-1","#m-4-1","#m-5-1","#m-6-1"]
    var p = "properties[";
    var p_p;
    
    var va = ["",[],"",""];
    var va_2 = ["","",""];
    
    if (v1) {
      va[0] = "women's)";
      va_2[0] = "women's";
    } else {
      va[0] = "men's)";
      va_2[0] = "men's";
    }
    
    if (v2 === "en") {
      
      $("#height-ft,#height-in").prop("required",true);
      $("#height-cm").prop("required",false);
      
      va[0] = " (US " + va[0];
      va[1] = [400,17];
      va[2] = " (in.)";
      va[3] = " (lbs.)";
      
      va_2[0] = "US " + va_2[0];
      va_2[1] = "in.";
      va_2[2] = "lbs.";
      
    } else {
      
      $("#height-ft,#height-in").prop("required",false);
      $("#height-cm").prop("required",true);
      
      if ( v2 === "uk" ) {
      
        va[0] = " (UK " + va[0];
        va[1] = [181,18];
        va[2] = " (cm.)";
        va[3] = " (kg.)";

        va_2[0] = "UK " + va_2[0];
        va_2[1] = "cm.";
        va_2[2] = "kg.";

      } else if ( v2 === "eu" ) {

        va[0] = " (EU)";
        va[1] = [181,50];
        va[2] = " (cm.)";
        va[3] = " (kg.)";

        va_2[0] = "EU";
        va_2[1] = "cm.";
        va_2[2] = "kg.";
        
      }
      
    }
    
    $("#w-span").text(va_2[2]);
    $("#s-span").text(va_2[0]);
    
    $("#m-1-span,#m-2-span,#m-3-span,#m-4-span,#m-5-span,#m-6-span").text(va[2]);
    //$("#weight").attr("max",va[1][0]);
    //$("#shoe_size").attr("max",va[1][1]);
    
    for ( var i = 0; i < p_l_1.length; i++) 
    {
      if ( p_l_1[i].includes("weight") ) {
        p_p = p + p_l_1[i] + va[3];
      } else if ( p_l_1[i].includes("shoe") ) {
        p_p = p + p_l_1[i] + va[0];
      } else {
        p_p = p + p_l_1[i] + va[2]; 
      }
        
      $(p_l_2[i]).attr("name",p_p);
    }
    
    if ( va3 == 1 ) {
      $("#sys-a").addClass("active");
      
    }
    
  };
  
  function getSys() {
    
    var sys;
    
    if($("#sys-a").hasClass("active")){ 
      
      sys = 0; 
      
    } else if ($("#sys-b").hasClass("active")) { 
      
      sys = 1; 
      
    } else if ($("#sys-c").hasClass("active")) { 
      
      sys = 2; 
      
    }
    
    return sys;
    
  };
  
  function triggerPopup(el_id) {
    
    var id_last = el_id.charAt(el_id.length-1);
    
    var id_pop = "#myPopup-" + id_last;
        
    if ($(id_pop).hasClass("show")) {
      
      $(id_pop).removeClass("show");
      
    } else {
      
      $(id_pop).addClass("show");
      
      for (var i = 1; i < 9; i++){
       
        if ( i != id_last) {
          id_pop = "#myPopup-" + i;
          $(id_pop).removeClass("show");
        }
        
      }
      
    }
    
  }
  
  function closePopups() {
    var k;
    for (var i = 1; i < 9; i++){
       
      k = "#myPopup-" + i;
      $(k).removeClass("show");
        
    }
    
  }
  
  /*
  function checkShoeSize(v_1) {
    var v1,v2,v3,v4;
    
    v1 = $('#shoe_size').val();
    v2 = $.isNumeric(v1);
    v4 = $('[name="id"] option:selected').text();
    
    if (v_1 == -1) {
      v3 = getSys();
    } else {
      v3 = v_1
    }
    
    //console.log("v3: " + v3)
    var sc,t1,t2;
   
    if ( v1 != "" && v2 && $.isNumeric(v3)) {
      
      if ( isW ) {
         
        if (v3 == 0) {
          
          if (v1 >= 7.5 && v1 <= 10) {
            sc = 0
          } else {
            sc = 1
          }
          
        } else if (v3 == 1) {
          
          if (v1 >= 5.5 && v1 <= 8) {
            sc = 0
          } else {
            sc = 1
          }
          
        } else if (v3 == 2) {
          
          if (v1 >= 38 && v1 <= 41) {
            sc = 0
          } else {
            sc = 1
          }
          
        }
        
        if( sc == 1 ) { 
          
          if (shoeLast[1] != v1) {
            
            triggerPopup("myPopup-7");
            
            var jump = document.getElementById("myPopup-7");
  		    jump.scrollIntoView({behavior: 'smooth', block: 'center'});
            jump.focus({preventScroll: true});
            
            shoeLast[0] = shoeLast[1];
            shoeLast[1] = v1;
          }
          
        }
        
        
      } else {
        
        if (v3 == 0) {
          
          if (v1 < 6) {
            sc = 0;
          } else if (v1 >= 6 && v1 < 9) {
            sc = 1;
          } else if (v1 >= 9 && v1 < 11.5) { 
            sc = 2;
          } else if (v1 >= 11.5 && v1 < 15) {
            sc = 3;
          } else {
            sc = 4;
          }
          
        } else if (v3 == 1) {
          
          if (v1 < 5) {
            sc = 0;
          } else if (v1 >= 5 && v1 < 8) {
            sc = 1;
          } else if (v1 >= 8 && v1 < 10.5) { 
            sc = 2;
          } else if (v1 >= 10.5 && v1 < 14) {
            sc = 3;
          } else {
            sc = 4;
          }
          
        } else if (v3 == 2) {
          
          if (v1 < 40.5) {
            sc = 0;
          } else if (v1 >= 40 && v1 < 43) {
            sc = 1;
          } else if (v1 >= 43 && v1 < 45) { 
            sc = 2;
          } else if (v1 >= 45 && v1 < 49) {
            sc = 3;
          } else {
            sc = 4;
          }
          
        }
        
        var option_val = getOptionIndex("sock");
        var spl = v4.split(" / ")[option_val].toLowerCase();
        
        //console.log("spl: " + spl)
        //console.log("sc: " + sc)
        t1 = (spl.includes("medium") && sc != 2);
        t2 = (spl.includes("large") && sc != 3);
        //console.log("t1: " + t1)
        //console.log("t2: " + t2)
        if( t1 || t2 ) { 
          
          if (shoeLast[1] != v1) {
            
            triggerPopup("myPopup-7");
            var jump = document.getElementById("myPopup-7");
  		    jump.scrollIntoView({behavior: 'smooth', block: 'center'});
            jump.focus({preventScroll: true});
            
            shoeLast[0] = shoeLast[1];
            shoeLast[1] = v1;
          }
        
        }
        
      }
      
    } else {
      
      //$('#s-t-b').hide(); 
      
    }
    
  };
  
  
  function hideExtraMeas() {
    
    //$("#hw-t-b").hide();
    $('#m-1-1,#m-2-1,#m-3-1,#m-4-1,#m-5-1,#m-6-1').prop('required',false);
    $('#m-1-1,#m-2-1,#m-3-1,#m-4-1,#m-5-1,#m-6-1').prop('readonly',true);
    //$('#m-1-1,#m-2-1,#m-3-1,#m-4-1,#m-5-1,#m-6-1').val("");
    
  };
  
  function checkMeasurements(v1,v2,v3,v4,v5,v6,v7,v8,v9) {
    
    //console.log("new start");
    //console.log("sizeLast: " + sizeLast);
    
    v9 = v9.toLowerCase();
    var t1 = (v1 == 0 && v2 && v3 && v4);
    var t2 = ((v1 == 1 || v1 == 2) && v2 && v4);
    var success = false;
    
    if( t1 || t2 ){
      
      var a_s,b_s;
      
        a_s = [[[[90,123],[0,62.5],[0,66.5]],[[123,132],[0,62.5],[-2/27,4083/54]]],
       		   	 [[[90,123],[0,67.5],[0,71]],[[123,144],[-2/27,4137/54],[0,71]],[[144,155],[0,66],[0,71]],[[155,160],[0,66],[-2/19,1659/19]]],
       			 [[[90,155],[0,72],[0,73]],[[155,174],[-2/19,1678/19],[0,73]],[[174,175],[0,66],[0,73]],[[175,185],[7/55,43.72],[0,73]],[[185,190],[7/55,43.72],[-1/5,112]]],
       			 [[[90,185],[0,74],[0,75]],[[185,190],[-1/5,107],[0,75]],[[190,197],[-1/2,168],[0,75]],[[197,210],[0,66],[0,75]]],
       			 [[[90,215],[0,76],[0,78]],[[215,231],[-17/80,121.6875],[0,78]],[[231,260],[1/6,86/3],[0,78]]]];
      
        b_s = [[[[90,100],[0,61],[0,66.5]],[[100,106],[0,61],[-19/200,76]],[[106,114],[-0.25,87.5],[-19/200,76]],[[114,120],[0,59],[-19/200,76]],[[120,130],[0,59],[-1/24,69.6]]],
        		 [[[90,100],[0,67.5],[0,69]],[[100,120],[-19/200,77],[0,69]],[[120,125],[-1/24,70.6],[0,69]],[[125,132],[-1/24,70.6],[-2/21,1699/21]],[[132,138],[-8/30,100.3],[-2/21,1699/21]],[[138,145],[0,61.3],[-2/21,1699/21]]],
        		 [[[90,125],[0,70],[0,72]],[[125,146],[-2/21,1720/21],[0,72]],[[146,167],[-1/24,1778/24],[0,72]],[[167,170],[-1/24,1778/24],[-24/125,104.064]]],
        		 [[[172.3,192],[-24/125,105.064],[0,72]],[[192,195],[0,60.5],[0,72]],[[195,200],[0,60.5],[-2/17,1597/17]]]];
      
      var i,j,k;
      var l_b,u_b;
      var tt1,tt2,tt3,tt4,tt5,tt6;
      var r = false;
      var q = false;
      i = 0;
      
      var option_val = getOptionIndex("ds_size")
      var spl = v9.split(" / ")[option_val];
              
      //console.log("right size value?: " + spl);
      
      if(isW){
        
        while( i < b_s.length && r == false) 
        {
          for(j = 0; j < b_s[i].length; j++)
          {

            if( v6*v7 >= b_s[i][j][0][0] && v6*v7 < b_s[i][j][0][1]){ //persons weight is within a weight range 
		
              l_b = (b_s[i][j][1][0]*v7*v6 + b_s[i][j][1][1])*v8;
              u_b = (b_s[i][j][2][0]*v7*v6 + b_s[i][j][2][1])*v8;
              
              //console.log('h: ' + v5 + ', w: ' + v6 + ', lb: ' + l_b + ', ub: ' + u_b + ', b_s_0: ' + b_s[i][j][0][0] + ', b_s_1: ' + b_s[i][j][0][1]);
              
              if(v5 >= l_b && v5 < u_b ){ 
                
                tt1 = ( (spl.includes("small") || spl.includes("sml") || spl.includes("sm")) && i == 0);
                tt2 = ( (spl.includes("medium") || spl.includes("med") || spl.includes("md")) && i == 1);
                tt3 = ( (spl.includes("large") || spl.includes("lrg") || spl.includes("lg")) && i == 2);
                tt4 = ( (spl.includes("xls") || spl.includes("x-large short") || spl.includes("extra large short")) && i == 3);
                //console.log("i: " + i);
                //console.log("has small: " + v9.includes("w small"));
                //console.log('tt1: ' + tt1 + ' ' +  ', tt2: ' + tt2 + ', tt3: ' + tt3 + ', tt4: ' + tt4 );
                
                if( tt1 || tt2 || tt3 || tt4 ) {
                  r = true; 
                }
              }
              
            }

          }

          i++;

        }
        
      } else {
        
        while( i < a_s.length && r == false)
        {
          for(j = 0; j < a_s[i].length; j++)
          {
             
            if( v6*v7 >= a_s[i][j][0][0] && v6*v7 < a_s[i][j][0][1]){ 
	
              
              l_b = (a_s[i][j][1][0]*v7*v6 + a_s[i][j][1][1])*v8;
              u_b = (a_s[i][j][2][0]*v7*v6 + a_s[i][j][2][1])*v8;
              
              //console.log('h: ' + v5 +', w: ' + v6 + ', lb: ' + l_b + ', ub: ' + u_b + ', b_s_0: ' + a_s[i][j][0][0] + ', b_s_1: ' + a_s[i][j][0][1]);
            
              if(v5 >= l_b && v5 < u_b ){ 
                
                tt1 = ( (spl.includes("small") || spl.includes("sml") || spl.includes("sm")) && i == 0);
                tt2 = ( (spl.includes("medium") || spl.includes("med") || spl.includes("md")) && i == 1);
                tt3 = ( (spl.includes("large")|| spl.includes("lrg") || spl.includes("lg")) && (!spl.includes("x") || !spl.includes("xx")) && i == 2);
                tt4 = ( (spl.includes("x-large") || spl.includes("x-l") || spl.includes("x-lrg") || spl.includes("x-lg")) && !spl.includes("xx") && i == 3);
                tt5 = ( (spl.includes("xx-large") || spl.includes("xx-l") || spl.includes("xx-lrg") || spl.includes("xx-lg")) && i == 4);
                tt6 = ( spl.includes("king") && i == 5);
                //console.log('tt1: ' + tt1 + ' ' +  ', tt2: ' + tt2 + ', tt3: ' + tt3 + ', tt4: ' + tt4 + ', tt5: ' + tt5 + ', tt6: ' + tt6);
                
                if( tt1 || tt2 || tt3 || tt4 || tt5 || tt6 ) {
                  r = true; 
                }
              } 
              
            }
          }

          i++;

        } 
        
      }
      
      if(r){
        
        //console.log(v1);
        
        getValues(5,v1);
        eraseValues(5);
        hideExtraMeas();
        
        sizeLast[v1] = 0;
        
        success = true;
        
      } else {
        
        getValues(3,v1);
        setValues(5,v1)
        
        
        if (sizeLast[v1] == 0) {
          
          triggerPopup("myPopup-8");
          c_l_m_b = 1;
          
          var jump = document.getElementById("myPopup-8");
  		  jump.scrollIntoView({behavior: 'smooth', block: 'center'});
          jump.focus({preventScroll: true});
           
          sizeLast[v1] = 1;
        }
          
        $('#m-1-1,#m-5-1,#m-6-1').prop('required',true);
        $('#m-1-1,#m-5-1,#m-6-1').prop('readonly',false);

        if(isW) {
          $('#m-3-1,#m-4-1').prop('required',true);
          $('#m-3-1,#m-4-1').prop('readonly',false);
        } else {
          $('#m-2-1').prop('required',true);
          $('#m-2-1').prop('readonly',false);
        }
          
        
      }
      
    }
    
    return success;
    
  };
  
  function macroCheckDim(v1) {
    
    var variant = $('[name="id"] option:selected').text();
    var sys;
    
    var bigSuccess;
    
    if(v1 == -1) {
      sys = getSys();
    } else {
      sys = v1;
    }
    
    var m1,m1_1,m2;
    var sc1,sc2;
    
    var w = $('#weight').val();
    m2 = $.isNumeric(w); 
    
    if (m2) {
      
      if (sys == 0) {

        m1 = $.isNumeric($('#height-ft').val());
        m1_1 = $.isNumeric($('#height-in').val()); 
		sc1 = 1; sc2 = 1;

        if (m1 && m1_1) {

          var h = $('#height-ft').val()*12 + $('#height-in').val()*1;

          bigSuccess = checkMeasurements(sys,m1,m1_1,m2,h,w,sc1,sc2,variant);

        } else if (m1 && !m1_1) {

          //alert("Please type in a valid foot value");
          $('#height-in').val("");

        } else if (!m1 && m1_1) {

          //alert("Please type in a valid inch value");
          $('#height-ft').val("");

        } else {

          //alert("Please type in a valid height");
          $('#height-ft').val("");
          $('#height-in').val("");

        }

      } else if (sys == 1 || sys == 2) {

        m1 = $.isNumeric($('#height-cm').val());

        sc1 = 2.20462; sc2 = 2.54;

        if (m1) {

          var h = $('#height-cm').val();

          bigSuccess = checkMeasurements(sys,m1,m1_1,m2,h,w,sc1,sc2,variant);

        } else {

          //alert("Please type in a valid height");
          $('#height-cm').val("");

        }

      }
      
    } else {
      
      hideExtraMeas();
       
    }
    
    return bigSuccess;
    
  };
  */
  
  $("#sys-a,#sys-b,#sys-c").click( function() {
  
    var val1 = $(this).attr("id");
    var sys = getSys();
    var y = [["en","#height-en","#height-me",true,false,0],
             ["uk","#height-me","#height-en",false,true,1],
             ["eu","#height-me","#height-en",false,true,2]];
    var i;
    var s;
    
    if (val1 == "sys-a") {
      
      i = 0;
      
    } else if (val1 == "sys-b") { 
    
      i = 1;
      
    } else if (val1 == "sys-c") {
      
      i = 2;
      
    }
    
    //console.log("button clicked: " + val1 + ", i:" + i);
    
    //console.log("getSys(): " + sys);
    
    if ( i != sys ) {

      ma_sys[0] = ma_sys[1];
      ma_sys[1] = sys;

      getValues(0,sys);
      eraseValues(0);

      initialize(isW,y[i][0],0);

      $(y[i][1]).show();
      $(y[i][2]).hide();

      $("#height-ft,#height-in").prop("required",y[i][3]);
      $("#height-cm").prop("required",y[i][4]);

      setValues(0,y[i][5]);
      //checkShoeSize(y[i][5]);
      //s = macroCheckDim(y[i][5]);
      
    }
      
  });
  
  $(document).mousedown(function(e) {
      
    closePopups();
    
  });
  
  /*
  $("#name,#height-ft,#height-in,#height-cm,#weight,#shoe_size,#m-1-1,#m-2-1,#m-3-1,#m-4-1,#m-5-1,#m-6-1").focus( function() {
    
    var s = macroCheckDim(-1);
    
    if (c_l_m_b == 1) {
       c_l_m_b = 0;
    } else {
	  checkShoeSize(-1);
    }
    
  });
  */
  
  $("#q-mark-1,#q-mark-2,#q-mark-3,#q-mark-4,#q-mark-5,#q-mark-6").click( function() {
    
    var id_last = $(this).attr("id");
    
    triggerPopup(id_last);
    
  });
  
  initialize(isW,"en",1);
});
  